import React from "react";

import { Box, makeStyles } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import clsx from "clsx";

const useStyles = (dark: boolean) =>
  makeStyles(theme => ({
    root: {
      padding: theme.spacing(1),
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      maxHeight: "96px",
      backgroundColor: dark ? "#0D73D9" : theme.palette.common.white,
    },
    skeleton: {
      backgroundColor: dark ? "#B0BEC5" : "rgba(0, 0, 0, 0.04)",
      margin: theme.spacing(1),
    },
    status: {
      marginRight: theme.spacing(0),
      marginLeft: theme.spacing(2.5),
    },
  }));

type NewsSkeletonProps = {
  dark?: boolean;
};

const NewsSkeleton: React.FC<NewsSkeletonProps> = ({ dark = false }) => {
  const classes = useStyles(dark)();
  return (
    <div className={classes.root}>
      <Skeleton
        variant="circle"
        height={16}
        width={16}
        className={clsx(classes.skeleton, classes.status)}
      />
      <Box flexGrow={1}>
        <Skeleton
          variant="text"
          width="85%"
          height={26}
          className={classes.skeleton}
        />
        <Skeleton
          variant="text"
          height={16}
          width="50%"
          className={classes.skeleton}
        />
      </Box>
      <Skeleton
        variant="circle"
        height={30}
        width={30}
        className={classes.skeleton}
      />
    </div>
  );
};

export default NewsSkeleton;
